import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { MaterialModule } from '../material.module';
import { PropertiesLoaderService } from '../vehicles/service/properties-loader.service';
import { ChatMessagesComponent } from './component/chat/chat-messages/chat-messages.component';
import { ChatSelectorComponent } from './component/chat/chat-selector/chat-selector.component';
import { ChatWindowComponent } from './component/chat/chat-window/chat-window.component';
import { ChatComponent } from './component/chat/chat.component';
import { MessageWindowComponent } from './component/chat/message-window/message-window.component';
import { PredefinedMessageFormComponent } from './component/chat/predefined-message-form/predefined-message-form.component';
import { InstructionComponent } from './component/instruction/instruction.component';
import { NotificationComponent } from './component/notification/notification.component';
import { TopBarComponent } from './component/top-bar/top-bar.component';

@NgModule({
  declarations: [
    ChatComponent,
    ChatWindowComponent,
    ChatMessagesComponent,
    ChatSelectorComponent,
    MessageWindowComponent,
    PredefinedMessageFormComponent,
    TopBarComponent,
    InstructionComponent,
    NotificationComponent
  ],
  imports: [
    CommonModule,
    DialogModule,
    MaterialModule,
    DataViewModule,
    RouterModule,
    ReactiveFormsModule,
    TranslateModule,
    FlexLayoutModule
  ],
  exports: [
    ChatComponent,
    ChatWindowComponent,
    ChatMessagesComponent,
    ChatSelectorComponent,
    MessageWindowComponent,
    PredefinedMessageFormComponent,
    TopBarComponent,
    InstructionComponent,
    NotificationComponent
  ],
  providers: [
    PropertiesLoaderService
  ]
})
export class TopBarModule { }
